define('shared/remote/order/item/extra/update',['shared/remote/ajax', 'shared/lib/RSVP'], 
function (ajax, RSVP) {

    var URL_BASE = '/1/api/commerce-gateway/order/item/';
    var URL_SUB = '/extra-info';

    function update(orderItemId, payload) {
        return ajax({
            url: URL_BASE + (orderItemId * 1) + URL_SUB,
            type: 'PATCH',
            contentType: 'application/json-patch+json',
            data: payload
        });
    }

    return function(options){
        var err;
        var nstc = !!options.needSignTermCondition;

        if (!options.id) {
            err = new Error('No order item id specified');
            return RSVP.reject(err);
        }

        if (nstc !== false && options.debug !== true) {
            err = new Error('NeedSignTermCondition is not allowed to be set to anything else other than false');
            return RSVP.reject(err);
        }

        var nstcString = nstc + '';
        nstcString = nstcString.charAt(0).toUpperCase() + nstcString.substr(1);
        var payload = {
            NeedSignTermCondition: nstcString
        };
        return update(options.id, payload);
    };
});
